<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <inbox-header :title="title" :path="path" :text="text" :text1="text1" />

      <div class="row">
        <div class="col-md-12">
          <table-page-size-changer />
          <ExportBtns
            :parent="this"
            :columns="columns"
            :data="filteredData"
            fileName="my-projects"
          />

          <div class="table-responsive table-newdatatable">
            <a-table
              class="stripped table-hover"
              :columns="columns"
              :data-source="data"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'id'">
                  {{ getSerialNumber(record) }}
                </template>
                <template v-if="column.key === 'action'">
                  <div class="table-actions d-flex justify-content-center">
                    <!-- <a
                      class="delete-table me-2"
                      href="javascript:;"
                      @click="selectedAssetDetails(record.id)"
                      data-bs-toggle="modal"
                      data-bs-target="#asset_details_modal"
                    > -->
                    <router-link :to="`/my-team/project/${record.id}`">
                      <img
                        :src="require(`@/assets/img/icons/eye.svg`)"
                        alt="Eye Icon"
                      />
                    </router-link>
                    <!-- </a> -->
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- Projects Tab -->
  <!-- /Projects Tab -->
</template>
<script>
// import ProjectCard from "./ProjectsList.vue";

import MyProjectService from "@/services/MyProjectService";
import ExportBtns from "@/components/ExportBtns.vue";

const columns = [
  {
    title: "Id ",
    dataIndex: "id",

    sorter: {
      compare: (a, b) => {
        a = a.id;
        b = b.id;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Code No",
    dataIndex: "project_code",
    sorter: {
      compare: (a, b) => {
        a = a.project_code.toLowerCase();
        b = b.project_code.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    sorter: {
      compare: (a, b) => {
        a = a.project_name.toLowerCase();
        b = b.project_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
    sorter: {
      compare: (a, b) => {
        a = a.start_date.toLowerCase();
        b = b.start_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Deadline",
    dataIndex: "end_date",
    sorter: {
      compare: (a, b) => {
        a = a.end_date.toLowerCase();
        b = b.end_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Priority",
    dataIndex: "priority",
    sorter: {
      compare: (a, b) => {
        a = a.priority.toLowerCase();
        b = b.priority.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "View Tasks",
    key: "action",
    sorter: true,
    class: "text-end",
  },
];

export default {
  components: {
    // ProjectCard,
    ExportBtns,
  },
  data() {
    return {
      title: "Projects",
      path: "ESS",
      text: "Projects",
      text1: "Add New",
      columns,
      data: [],
      filteredData: [],
      selectedAsset: {},
      assetDetails: {},
    };
  },
  methods: {
    getSerialNumber(record) {
      const index = this.filteredData?.findIndex(
        (item) => item.id === record.id
      );
      return index + 1;
    },
    //   selectedAssetDetails(id) {
    //     this.selectedAsset = this.data.find((asset) => asset.id === id);
    //     this.assetDetails = this.selectedAsset.asset_detail;
    //   },
  },

  async created() {
    try {
      const response = await MyProjectService.getProjects();
      this.data = response.data;
      this.filteredData = response.data;
    } catch (error) {
      console.log("error fetching projects", error);
    }
  },
};
</script>
